<template>
  <section class="px-0 py-6 md:px-6" :class="{'flex h-screen items-center justify-center':isFormScreen}">
    <slot/>
  </section>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'MainSection',
  setup () {

    const isFormScreen = computed(() => false)

    return {
      isFormScreen
    }
  }
}
</script>
